<template>
  <v-row justify="center">
    <v-dialog
      v-model="deleteCampingDialogState"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Suppression de camping</span>
        </v-card-title>
        <v-container>
          <v-card-text>
            <p v-if="successMessage">
              <v-alert
                text
                dense
                color="teal"
                border="left"
                type="success"
              >
                {{ successMessage }}
              </v-alert>
            </p>

            <span v-if="camping">Etes-vous sûr de vouloir supprimer le camping <strong>{{ camping.name }}</strong> ?</span>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDeleteCampingDialog(false)"
          >
            Annuler
          </v-btn>

          <button
            type="button"
            :disabled="loading"
            class="v-btn v-btn--flat v-btn--text theme--light v-size--default blue--text text--darken-1"
            @click="deleteCamping(camping)"
          >
            <span class="v-btn__content">Valider</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import config from '../../../config'

export default {
  name: 'DeleteCampingDialog',
  props: {
    camping: {
      type: Object,
      default: () => {
        return {}
      }
    },
    deleteCampingDialogState: Boolean
  },
  data: () => ({
    successMessage: null,
    loading: false,
    errors: []
  }),
  methods: {
    deleteCamping (camping) {
      this.loading = true

      Vue.prototype.$http
        .delete(config.apiUrl + '/api/campings/' + camping.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 204) {
            this.successMessage = 'Le camping a été supprimé.'
            this.errors = []
            this.closeDeleteCampingDialog(true)
          }

          this.loading = false
        })
        .catch(e => {
          this.loading = false

          const response = e.response

          if (response && response.status === 400) {
            const data = response.data
            this.errors = data.violations
            this.successMessage = null
          }

          if (response.status === 500) {
            this.errors.push({
              title: 'Une erreur est intervenue lors de la suppression du camping.'
            })
          }
        })
    },
    closeDeleteCampingDialog (deleteState) {
      this.$emit('closeDeleteCampingDialog', deleteState)
    }
  }
}
</script>

